import { Event } from 'microevent.ts';

const eventBus = new Event<string>();

export { eventBus };
